const state = {
  location: null
};

const getters = {
  processorLocation({ location }) {
    return location;
  }
};

const mutations = {
  setProcessorLocation(state, location) {
    state.location = location;
  }
};

const actions = {
  clearProcessorLocation({ commit }) {
    commit("setProcessorLocation", null);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
